import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getDefectRulesets } from '../api/rulesets';
import { SurveyDataManagerApiError } from '../contracts/common';
import { DefectRulesetsResponseBody } from '../contracts/defectRulesets';
import { surveyDataManagerQueryKeys } from './queryKeys';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useDefectRulesets(
  slug: string,
  refreshData: boolean = false,
  enabled: boolean = true,
): UseQueryResult<DefectRulesetsResponseBody, SurveyDataManagerApiError> {
  return useQuery<DefectRulesetsResponseBody, SurveyDataManagerApiError>({
    queryKey: surveyDataManagerQueryKeys.defectRulesets(slug),
    queryFn: () => getDefectRulesets(slug, refreshData),
    staleTime: FIVE_MINUTES_MS,
    enabled: enabled && Boolean(slug),
  });
}
